import { render, staticRenderFns } from "./BaseDragArea.vue?vue&type=template&id=3ac2a79e&scoped=true"
import script from "./BaseDragArea.vue?vue&type=script&lang=js"
export * from "./BaseDragArea.vue?vue&type=script&lang=js"
import style0 from "./BaseDragArea.vue?vue&type=style&index=0&id=3ac2a79e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ac2a79e",
  null
  
)

export default component.exports